export default __webpack_public_path__ + "static/project-hazeos-e2adf0ce4c2014cc5ec5a6c1f44bd378.png";